<template>
  <b-modal
    id="SaveUserAccessKeyModal"
    ref="saveuserAccessKeyModal"
    class="modal"
    size="lg"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
  >
    <template
      slot="modal-header"
    >
      <h5>Add Public SSH Key</h5>
      <button
        class="btn btn--close"
        @click="close()"
      >
        <font-awesome-icon
          :icon="['fal', 'times']"
          class="icon alt"
        />
      </button>
    </template>

    <form-component>
      <form
        novalidate="novalidate"
        @submit.prevent
      >
        <div
          v-if="hadError"
          class="error-red"
        >
          There was an error saving your public key.
          Please verify that it is valid and re-attempt to save.
        </div>
        <input-text
          id="description"
          v-model="description"
          v-validate="'required'"
          name="description"
          data-vv-name="description"
          data-vv-as="description"
          label="Description"
          type="text"
          required
          :error="errors.first('description')"
        />

        <input-text-area
          id="publicKey"
          v-model="publicKey"
          v-validate="'required'"
          name="publicKey"
          data-vv-name="publicKey"
          data-vv-as="publicKey"
          label="Public Key"
          type="text"
          rows="20"
          required
          :error="errors.first('publicKey')"
        />
      </form>
    </form-component>

    <template
      slot="modal-footer"
    >
      <button
        class="btn"
        type="button"
        @click="close()"
      >
        Cancel
      </button>
      <button
        class="btn btn--primary"
        type="button"
        :disabled="saving"
        @click="save()"
      >
        <font-awesome-icon
          v-if="saving"
          :spin="true"
          :icon="['fas', 'spinner']"
          class="icon alt"
        />
        <span v-else>Save</span>
      </button>
    </template>
  </b-modal>
</template>

<script>
/* eslint-disable vue/require-default-prop */
import FormComponent from '@/components/FormComponent.vue';
import InputText from '@/components/inputs/InputText.vue';
import InputTextArea from '@/components/inputs/InputTextArea.vue';

export default {
  name: 'SaveUserAccessKeyModal',
  components: {
    FormComponent,
    InputText,
    InputTextArea,
  },
  props: {
    doSave: {
      type: Function,
    },
    doCancel: {
      type: Function,
    },
  },
  data: () => ({
    description: '',
    publicKey: '',
    saving: false,
    hadError: false,
  }),
  methods: {
    save() {
      this.hadError = false;

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.errors.clear();
          this.saving = true;
          this.doSave({
            description: this.description,
            publicKey: this.publicKey,
          });
        }
      });
    },
    show() {
      this.description = '';
      this.publicKey = '';
      this.saving = false;
      this.$refs.saveuserAccessKeyModal.show();
    },
    catchError() {
      this.hadError = true;
      this.saving = false;
    },
    close() {
      this.$refs.saveuserAccessKeyModal.hide();
    },
  },
};
</script>

<style scoped lang="scss">

</style>
